import React, { FC, useMemo } from 'react';
import { ButtonIcon, Tooltip } from '@cubeyou-team/hx-react-components';
import { useSelector } from 'react-redux';

import { isEmpty } from 'src/utils';
import { QUERY_BUILDER_TYPES } from 'src/modules/query-builder/constants';

interface DeleteAudienceButtonProps {
  target: any;
  isQueryLoading: boolean;
  onClearQueryRequest: () => void;
}

export const DeleteAudienceButton: FC<DeleteAudienceButtonProps> = ({
  target,
  isQueryLoading,
  onClearQueryRequest,
}) => {
  const queryBuilderType = useSelector(
    (state: any) => state.queryBuilder.queryBuilderType
  );

  const isClearEnabled = useMemo(() => {
    return (
      target &&
      target.target_query &&
      !isEmpty(target.target_query.arguments_list)
    );
  }, [target]);

  const isQueryValid = (queryBuilderType, target) => {
    if (!target) return false;

    const { target_query, conversationQueries } = target;
    const conversationValues =
      conversationQueries && Object.values(conversationQueries);
    const firstItemValue = conversationValues && conversationValues[0];

    if (queryBuilderType === QUERY_BUILDER_TYPES.CONVERSATION) {
      return (
        target_query.arguments_list &&
        ((target_query.arguments_list.length === 1 &&
          !isEmpty(firstItemValue)) ||
          target_query.arguments_list.length > 1)
      );
    }
    return target_query.arguments_list.length > 0 || false;
  };

  return (
    <Tooltip content="Clear query" position="bottom" isInfoLabel>
      <ButtonIcon
        icon="delete"
        onClick={onClearQueryRequest}
        size="small"
        type="button"
        variant={
          isQueryValid(queryBuilderType, target) ? 'secondary' : 'dark_lighter'
        }
        disabled={!isClearEnabled || isQueryLoading}
        dataTestId="clear-query-btn"
      />
    </Tooltip>
  );
};
